import type React from "react";
import cookieStorage from "../../persistence";
import type { ROLES, RoleComponentProps } from "./RoleComponent.model";

export const RoleComponent: React.FC<RoleComponentProps> = ({ children, allowedRoles = [] }) => {
  const role = cookieStorage.getRole() as ROLES;

  const notIncludeRole = (): boolean => !allowedRoles.includes(role);
  if (notIncludeRole()) return null;

  return <>{children}</>;
};
